module.exports = __webpack_public_path__ + "static/img/til21.d8a3f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til21.png
// module id = m+gI
// module chunks = 1